import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CommandItem } from 'cmdk';
import { CheckIcon } from '../../icons';
import { cn } from '../../utils';
export function SelectOption({ option, isSelected, onSelect, style }) {
    return (_jsxs(CommandItem, { value: String(option.value), onSelect: onSelect, style: style, className: cn('p-stack cursor-pointer focus:outline-none text-body-sm text-fg-muted', 'flex items-center gap-stack w-full data-[selected=true]:bg-bg-subtle/50', 'absolute top-0 left-0 w-full', {
            'pr-stack-section': !isSelected,
        }), children: [option.image && (_jsx("img", { src: option.image, className: "rounded-pill w-6" })), _jsx("span", { className: "truncate", children: option.value }), isSelected && (_jsx(CheckIcon, { className: "size-4 text-brand-hover ml-auto" }))] }));
}
